<template>
  <CRow>
    <CCol sm="6">
      <div class="p-3 font-weight-medium">{{ key || '-' }}</div>
    </CCol>
    <!-- click.stop prevents event bubbling -->
    <CCol sm="auto" @click.stop="" style="cursor: default">
      <div class="p-3 d-flex align-items-center">
        <label v-translate translate-context="form_configurator" class="mr-2" style="font-size: 12px">Required</label>
        <CSwitch :checked.sync="mandatory" variant="3d" color="primary" size="sm"
                 :label="$pgettext('form_configurator','Field is mandatory')"
                 @update:checked="save()"/>
      </div>
    </CCol>
  </CRow>
</template>

<script>
export default {
  name: "CompactConsentInput",
  props: {
    data: {
      type: Object,
      required: true
    },
    fieldType: {
      type: String,
      required: true
    }
  },
  computed: {},
  data() {
    return {
      key: '',
      mandatory: false,
    }
  },
  emits: ['save'],
  watch: {
    data: function () {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.key = this.data.key ?? ''
      this.mandatory = this.data.mandatory ?? false
    },
    save() {
      this.$emit('save', {
        mandatory: this.mandatory,
      })
    }
  }
}
</script>